import CourseCodeData from './CourseCodeReportData';

export default CourseCodeData;
export * from './CourseCodeReportConstant';
